//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 22.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.layout')
        .directive('srsngNavigation', srsngNavigation);

    function srsngNavigation() {

        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'container/ui/app/layout/navigation/navigation.html',
            controller: controller
        };

        function controller($scope, $rootScope, $compile, navigationService, $state) {

            $rootScope.$on('navigationService:statesChanged', getStates);

            $scope.flyOut = {};
            $scope.showSubMenu = showSubMenu;
            $scope.subMenuVisible = subMenuVisible;
            $scope.hasSubMenuItems = hasSubMenuItems;
            $scope.removeAllFlyOuts = removeAllFlyOuts;
            $scope.isSubMenuUnderlined = isSubMenuUnderlined;
            $scope.isUnderlined = isUnderlined;

            getStates();

            function getStates() {
                $scope.states = navigationService.getStates();
            }

            $scope.$watch('flyOut.visible', newVal => {
                if (!newVal) {
                    let item = $scope.flyOut.state;

                    setTimeout(() => {
                        if ($scope.flyOut.state === item) $scope.flyOut = {};
                    }, 0)
                }
            });

            $scope.$on('$stateChangeStart', function (event, toState) {
                let currentState;
                $scope.states.forEach((item, index) => {
                    if (item.name === toState.name){
                        currentState = item;
                    }
                });
                if (currentState && currentState.functionMenu && currentState.functionMenu.length > 0) {
                    event.preventDefault();
                }
            });

            function showSubMenu(event, state, enabled) {
                $scope.flyOut.visible = false;
                if (!enabled) return;
                if (!state.functionMenu || state.functionMenu.length === 0)
                    return;

                    $scope.flyOut = {
                        visible: true,
                        functionMenu: state.functionMenu,
                        state: state
                    };
                  //sprint review 5.3.4 BLR Team
                  if($scope.flyOut.functionMenu.length){
                    $compile(`
                        <srsng-popup class="flyOutMenu" visible="flyOut.visible" target=".menuContent" anchor="center bottom" align="center top" offset="0 8" arrow="top" remove-on-hide>
                            <div class="action-menu">
                                <div class="list">
                                    <a class="item" data-cy="{{action.label}}" ng-if="action.enabled" ng-repeat="action in flyOut.functionMenu" ui-sref="{{action.state}}" ng-click="removeAllFlyOuts()">
                                        <span class="label">{{action.label | translate}}</span>                                        
                                    </a>
                                    <a class="item" data-cy ="{{action.label}}" ng-if="!action.enabled" ng-class="action.enabled?'':'disabled'" ng-repeat="action in flyOut.functionMenu">
                                        <span class="label">{{action.label | translate}}</span>
                                        <ng-include src="'container/ui/assets/img/icons/system-icons-16x16/system-ic-locked-16x16.svg'" class="lock-image"></ng-include>
                                    </a>
                                </div>
                            </div>
                        </srsng-popup>
                    `)($scope, element => {
                        removeAllFlyOuts();
                        element.insertAfter(event.currentTarget);
                    });
                }

                event.stopPropagation();
            }

            function removeAllFlyOuts() {
                $('.flyOutMenu').remove();
            }

            function subMenuVisible(state) {
                return $scope.flyOut.visible && $scope.flyOut.state === state;
            }

            function isSubMenuUnderlined(state) {
                return hasSubMenuItems(state) && $state.current.name.indexOf(state.name) !== -1;
            }

            function isUnderlined(state) {
                return $state.current.name.indexOf(state.name) !== -1;
            }

            function hasSubMenuItems(state) {
                return state.functionMenu && state.functionMenu.length > 0;
            }
        }
    }
}());
